import * as React from 'react';

const SvgIconAdventurer = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M12.706.779a.749.749 0 00-.956.721v3l4.589-1.419a.75.75 0 00-.089-1.411L12.706.779zM19.25 10.125a2.564 2.564 0 01-2.5 2.625 2.5 2.5 0 01-2.289-1.576 3.12 3.12 0 01-5.422 0A2.5 2.5 0 016.75 12.75a2.564 2.564 0 01-2.5-2.625.73.73 0 01.293-.59L11.75 4.5l7.2 5.049c.19.13.302.346.3.576zM10.75 17.25h2a2 2 0 012 2v4h-6v-4a2 2 0 012-2z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.323 10.758c.077 3.59-.438 7.17-1.523 10.593a1.5 1.5 0 001.447 1.9h15a1.5 1.5 0 001.447-1.9 32.733 32.733 0 01-1.52-10.593M11.75 4.5l-2.711 6.674M11.75 4.5l2.711 6.674"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconAdventurer;
